<div class="ap-margin-bottom-3">
    {{ 'extra-asset.own-money.button' | coApplicantPipe: store.hasCoApplicant | apContent }}
</div>

<ap-button-group id="ownMoney" [formControl]="mainApplicantControl" (buttonGroupClicked)="onButtonGroupClicked($event)">
    <ap-button-group-item label="{{ 'general.button-group.yes' | apContent }}" value="true"> </ap-button-group-item>
    <ap-button-group-item label="{{ 'general.button-group.no' | apContent }}" value="false"> </ap-button-group-item>
</ap-button-group>

<additional-info
    [key]="questionKey"
    titleKey="extra-asset.own-money.button.additional-info.text"
    contentKey="extra-asset.own-money.button.additional-info.content"
    modalUrlKey="extra-asset.own-money.button.additional-info.text"
></additional-info>
